import { useQuery } from "@tanstack/react-query";
import { calendarGetRange } from "../api";
import { DateTime } from "luxon";

export function useCommonAndCompanyEvents(dateRange) {
  return useQuery({
    queryKey: ["commonCompanyEvents", dateRange],
    enabled: !!dateRange,
    queryFn: async () => {
      const { start, end } = dateRange;
      const res = await calendarGetRange(start, end);
      if (res.status !== 200) throw new Error("Failed to load events");

      return res.data
        .filter(e => e.scope === "COMMON" || e.scope === "COMPANY")
        .map(e => ({
          ...e,
          startDateISO: DateTime.fromISO(e.startDate).toISODate(),
          endDateISO: DateTime.fromISO(e.endDate).toISODate(),
        }));
    }
  });
}
